module.exports = __webpack_public_path__ + "img/dark-like-active.43d86d0b.svg";